import React, {useCallback, useEffect, useState} from 'react';
import {ApiQueryParam, ApiService} from "../../../../service/ApiService";
import {BoxTitle} from "../../../../components/admin/BoxTitle";
import {member} from "../../../../models/member";
import {memberResultCollectionType, memberResultType} from "../../../../types/Api/MemberResultType";
import {memberHydrator} from "../../../../models/hydrator/memberHydrator";
import {MemberList} from "../../../../components/admin/member/MemberList";
import {Pagination} from "../../../../components/admin/Pagination";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../../service/ToolsService";
import {defaultPagination} from "../../../../types/PaginationType";
import {Tab} from "../../../../components/admin/office/Tab";

export const List = () => {
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [members, setMembers] = useState([] as member[]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(15);
  const [pagination, setPagination] = useState(defaultPagination);

  const findMember = useCallback((): void => {
    const apiFilters: ApiQueryParam = new ApiQueryParam();

    apiFilters.addSort({
      by: 'firstname',
      direction: 'ASC'
    });

    apiFilters.addSort({
      by: 'name',
      direction: 'ASC'
    });

    apiFilters.setPage(page);
    apiFilters.setCount(count);

    setLoading(true);

    const result: Promise<memberResultCollectionType> = ApiService.get('/member', apiFilters) as Promise<memberResultCollectionType>;

    result
      .then((r: memberResultCollectionType) => {
        setInitialized(true);
        setPagination({
          page: r._page,
          pageCount: r._page_count,
          total: r._total_items,
          count: count,
        });

        setMembers(r._embedded.members.map((member: memberResultType) => {
          return memberHydrator.hydrate(member);
        }));
      })
      .catch(() => {
        alert("Une erreur c'est produite.")

        setPagination(defaultPagination);
        setMembers([]);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [page, count]);

  useEffect(() => {
    findMember();
  }, [findMember]);

  return (
    <>
      <BoxTitle title="Gestion des membres"/>
      <Tab />
      <MemberList members={members} loading={loading} refresh={findMember}/>
      {initialized && (
        <Pagination pagination={pagination}
                    paginate={(p: number) => {
                      if (!loading) {
                        setPage(p);
                      }
                    }}
                    count={(c: number) => {
                      if (!loading) {
                        setPage(1);
                        setCount(c);
                      }
                    }}
        />
      )}
      <div className="mt-3 text-end">
        <NavLink to={`/admin/office/member/add`} onClick={scrollTo} className="btn btn-sm btn-primary me-1">
          <i className="fa-solid fa-plus me-1"/> Ajouter un membre
        </NavLink>
      </div>
    </>
  )
}
